import { ReducerState } from '../stateUtils/reducerTypes';
import { DndData } from './types';
import { findParentSubqueryIdOfRowId } from '../stateUtils/utils';

export const collectDecendantRuleIds = (
  subqueryId: string | null,
  queryBuilderState: ReducerState
): string[] => {
  if (!subqueryId) return [];
  if (!queryBuilderState.tree[subqueryId]) return [subqueryId];
  return queryBuilderState.tree[subqueryId].flatMap(childId => {
    // if there is no subtree it meas this is a ruleId (child of subqueryId)
    if (!queryBuilderState.tree[subqueryId]) return childId;
    return collectDecendantRuleIds(childId, queryBuilderState);
  });
};

export const findLevelOfRow = (
  ruleId: string,
  queryBuilderState: ReducerState
) => {
  let i = 0;
  let parentQueryId = findParentSubqueryIdOfRowId(ruleId, queryBuilderState);
  while (parentQueryId) {
    i++;
    parentQueryId = findParentSubqueryIdOfRowId(
      parentQueryId,
      queryBuilderState
    );
  }
  return i;
};

export const getIsRowTheOnlyChildOfSubquery = (
  rowId: string,
  queryBuilderState: ReducerState
) => {
  const parentSubqueryId = findParentSubqueryIdOfRowId(
    rowId,
    queryBuilderState
  );
  return Boolean(
    !parentSubqueryId || queryBuilderState.tree[parentSubqueryId].length === 1
  );
};

export const getRenderPlaceholderPositionUtil = (
  rowId: string,
  { overRuleId, draggedRowId, draggedRowType, position }: DndData,
  queryBuilderState: ReducerState
) => {
  const isDraggingRowOverItself = draggedRowId === rowId;
  // Don't allow to drag subqery to another subquery
  // which is already on maximal level of nesting
  const isDraggingSubqueryOverMaxLevelSubquery =
    draggedRowType === 'query' &&
    queryBuilderState.maxSubqueryNestingLevel <
      findLevelOfRow(rowId, queryBuilderState);
  const isDraggingSubqueryOverItsOwnDescendants =
    draggedRowType === 'query' &&
    collectDecendantRuleIds(draggedRowId, queryBuilderState).includes(rowId);
  if (
    isDraggingRowOverItself ||
    isDraggingSubqueryOverMaxLevelSubquery ||
    isDraggingSubqueryOverItsOwnDescendants
  ) {
    return null;
  }
  if (rowId === overRuleId) return position;
  return null;
};

export const getIsDragglableUtil = (
  rowId: string,
  queryBuilderState: ReducerState
) => !getIsRowTheOnlyChildOfSubquery(rowId, queryBuilderState);

export const getIsDropValid = (
  dndData: DndData,
  queryBuilderState: ReducerState
) =>
  Boolean(
    dndData.overRuleId &&
    getRenderPlaceholderPositionUtil(
      dndData.overRuleId,
      dndData,
      queryBuilderState
    )
  );
